import { ConstructDelete } from '../../../types/ConstructDelete';
import { USER_BASE_PATH } from '../constants/userBasePath';

export const deleteUser = async (
  constructDelete: ConstructDelete,
  uuid: string,
): Promise<undefined> =>
  constructDelete<undefined>(`${USER_BASE_PATH}/${uuid}/delete`, undefined, {
    preventDefaultErrorToast: true,
  });
